export const REFERRER_ID_KEY = 'referrer_id';

export const CART_STORAGE_KEY = 'stryd_shopping_cart';
